import { MESSAGES_EVENTS } from '../../../../config/config';
import socket from '../../../socket';

export default async (_, { to, config, photoMessage }) => {
  socket.emit(MESSAGES_EVENTS.REMOTE_CONFIG, { to, config, photoMessage });
};
